module.exports = __webpack_public_path__ + "img/view-inactive.6e86ce85.svg";